// extracted by mini-css-extract-plugin
module.exports = {"container":"comment_delete_container__GudBP","alertInfo":"comment_delete_alertInfo__26qz7"};